import { Component } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  hideElement = false;
  showElement = false;

  constructor(private route: ActivatedRoute, public router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.hideElement = true;
        } else {
          this.hideElement = false;
        }

        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.showElement = false;
        } else {
          this.showElement = true;
        }
      }
    });
  }

  onAnchorClick() {
    this.route.fragment.subscribe((f) => {
      const element = document.querySelector("#" + f);
      if (element) {
        element.scrollIntoView();
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((s) => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element) {
            element.scrollIntoView();
          }
        }
      }
    });
  }

  contacts = [
    /*{
      icon: "fa fa-envelope",
      text: "hello@mjmontero.com",
      url: "mailto:hello@mjmontero.com"
    },*/
    {
      icon: "fab fa-linkedin",
      text: "mariajosemontero19",
      url: "http://www.linkedin.com/in/mariajosemontero19",
    },
    {
      icon: "fab fa-github",
      text: "marimontero",
      url: "https://github.com/marimontero",
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts